// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3191e4a","453":"0adc40b5","455":"1d916e6f","977":"daa778db"}[chunkId] + ".chunk.js";
};